import Vue from 'vue'
import Router from 'vue-router'
import _ from 'lodash'

import contentManagerRoutes from './contentManager'
import verificationSpecialistRoutes from './verificationSpecialist'
import curatorRoutes from './curator'
import studentsRoutes from './students'
import adminRoutes from './admin'
import educationRoutes from './education'
import newsFeedRoutes from './news-feed'
import commonRoutes from './common'
import noAuthRoutes from './notAuth'
import classRoutes from './class'
import gatheringRoutes from './gathering'
import professionRoutes from './profession'

import { roles } from '@/config/roles'

import store from '@/store/index'

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (store.getters['currentUser/isAuthenticated']) {
    next()
    return
  }
  if (to.path === '/news_feed' && from.path === '/') {
    next('/main')
    return
  }
  next('/login')
}

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters['currentUser/isAuthenticated']) {
    next()
    return
  }
  store.dispatch('toasts/pushToasts', {
    title: 'Уведомление',
    error: true,
    message: 'Вы уже вошли в систему. Страница недоступна для пользователей, выполнивших вход.',
    time: 5
  })
  next('/main')
}
const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  routes: [
    {
      path: '/',
      redirect: () => (store.getters['currentUser/isAuthenticated'] ? '/news_feed' : '/main')
    },
    ...commonRoutes,
    ...contentManagerRoutes.map((route) => ({ ...route, beforeEnter: ifAuthenticated })),
    ...verificationSpecialistRoutes
      .map((route) => ({ ...route, beforeEnter: ifAuthenticated })),
    ...curatorRoutes.map((route) => ({ ...route, beforeEnter: ifAuthenticated })),
    ...studentsRoutes.map((route) => ({ ...route, beforeEnter: ifAuthenticated })),
    ...adminRoutes.map((route) => ({ ...route, beforeEnter: ifAuthenticated })),
    ...educationRoutes.map((route) => ({ ...route, beforeEnter: ifAuthenticated })),
    ...classRoutes.map((route) => ({ ...route, beforeEnter: ifAuthenticated })),
    ...newsFeedRoutes.map((route) => ({ ...route, beforeEnter: ifAuthenticated })),
    ...gatheringRoutes.map((route) => ({ ...route, beforeEnter: ifAuthenticated })),
    ...noAuthRoutes.map((route) => ({ ...route, beforeEnter: ifNotAuthenticated })),
    ...professionRoutes.map((route) => ({ ...route, beforeEnter: ifAuthenticated })),
    {
      path: '/notifications',
      name: 'NotificationsPage',
      meta: { label: '' },
      beforeEnter: ifAuthenticated,
      component: () => import('@/views/common/Notifications.vue')
    },
    {
      path: '/profile',
      name: 'ProfilePage',
      meta: { label: '' },
      beforeEnter: ifAuthenticated,
      component: () => import('@/views/common/Profile.vue')
    },
    {
      name: 'UniversityChoosingPage',
      path: '/university',
      meta: { label: '' },
      beforeEnter: ifAuthenticated,
      component: () => import('@/views/common/University.vue')
    },
    // {
    //   path: '/messages/contacts',
    //   name: 'ContactsPage',
    //   meta: { label: '' },
    //   beforeEnter: ifAuthenticated,
    //   component: () => import('@/views/common/chats/Contacts.vue')
    // },
    // {
    //   name: 'ChatsPage',
    //   path: '/messages/chats',
    //   beforeEnter: ifAuthenticated,
    //   component: () => import('@/views/common/chats/index.vue')
    // },
    // {
    //   name: 'ChatPage',
    //   path: '/messages/chats/:id',
    //   beforeEnter: ifAuthenticated,
    //   component: () => import('@/views/common/chats/Chat.vue')
    // },
    {
      path: '/page_not_exist',
      name: 'PageNotExist',
      component: () => import('@/views/common/PageNotExist.vue')
    },
    {
      path: '*',
      redirect: '/page_not_exist'
    }
  ]
})


const debounceNotsAndChats = _.debounce(() => {
  store.dispatch('notifications/fetchUnreadNots')
  store.dispatch('notifications/fetchLatestNots')
  store.dispatch('chats/fetchUnreadChats')
}, 1000)

router.beforeEach((to, from, next) => {
  if (store.getters['currentUser/isAuthenticated']) {
    debounceNotsAndChats()
    if (store.getters['currentUser/hasRole'](roles.verification)) {
      store.dispatch('content/fetchCountOfWaitingContent')
    }
  }
  if (to.meta && to.meta.roles) {
    const rolesForRouter = to.matched.some((record) => {
      if (record.meta.roles) {
        for (const role of record.meta.roles) {
          if (store.getters['currentUser/hasRole'](role)) {
            return true
          }
        }
      }
      return false
    })
    if (!rolesForRouter) {
      return next('/main')
    }
  }
  return next()
})

export default router
